import Main from '../components/Main'

export default [
  {
    path: '/parceiro/contratacao',
    name: 'ParceiroContratacao',
    component: Main,
    meta: { requiresAuth: true }
  },
  {
    path: '/parceiro/contratacao/:id',
    name: 'ParceiroContratacaoPorFreteId',
    component: Main,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/modules/Parceiro/Contratacao/routes/index.js